import { Button } from '@mui/material'
import styles from './EFButton.module.scss'
import classNames from 'classnames/bind'
import { currentTheme } from '~/redux/features'
import { useAppSelector } from '~/app/hooks'
import { camalize } from '~/utils'
import { EFButtonProps } from './EFButton.model'
import { Spinner } from '../EFLoading'

const cx = classNames.bind(styles)
export function EFButton(props: EFButtonProps) {
  const {
    style,
    children,
    className,
    disabled,
    startIcon,
    endIcon,
    isLoading,
    ...otherProps
  } = props
  const theme = useAppSelector(currentTheme)
  return (
    <div className={cx('button-block')}>
      <Button
        {...otherProps}
        aria-hidden='true'
        id={`button-${camalize(children?.toString() ?? '')}${
          props.id ? '-' + camalize(props.id) : ''
        }`}
        startIcon={isLoading ? <Spinner /> : startIcon}
        endIcon={endIcon}
        disabled={disabled || isLoading}
        className={cx('action-button', className, theme)}
        style={style}
      >
        {children}
      </Button>
    </div>
  )
}
